import { PageHeaderMini } from 'components/eventView/layout/PageHeaderMini';
import { EventViewEntityPageContent } from 'components/eventView/pages/EVEntityPageContent';
import { StickyHeaderLayout } from 'elements/eventView/layout/StickyHeaderLayout';
import { motion } from 'framer-motion';
import { useContext } from 'react';
import { useParams } from 'react-router';
import { CtxEventView } from 'session/ctxEventView';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
    detailId?: string;
}

export const EVDetailPageMobile = (props: Props) => {
    const { detailId } = useParams() as { detailId: string };
    const ctxEventView = useContext(CtxEventView);

    const { allStories } = ctxEventView;

    const storyId = props.detailId ?? detailId;

    const story = allStories.find((e) => e.storyId === storyId);

    if (!story) {
        return;
    }

    return (
        <S_EVDetailPageMobile $isFixed={!ctxEventView.isPreview} className={props.className}>
            <StickyHeaderLayout>
                <PageHeaderMini>{story.title}</PageHeaderMini>
            </StickyHeaderLayout>
            <S_EVEntityPageContent $isFixed={!ctxEventView.isPreview} detailId={storyId} />
        </S_EVDetailPageMobile>
    );
};

const S_EVDetailPageMobile = styled(motion.div)<{ $isFixed: boolean }>`
    position: absolute;
    top: 0;
    padding-top: 70px;
    bottom: 0;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 78px;
    background: #f1f2f4;
    ${(props) => {
        if (props.$isFixed) {
            return css`
                padding-top: 70px;
                height: 100vh;
            `;
        } else {
            return css`
                padding-top: 65px;
            `;
        }
    }}
`;

const S_EVEntityPageContent = styled(EventViewEntityPageContent)<{ $isFixed: boolean }>`
    ${(props) => {
        if (props.$isFixed) {
            return css`
                position: fixed;
                top: 0;
                bottom: 0;
                height: 100vh;
                overflow-y: auto;
                overflow-x: hidden;
                padding-bottom: 78px;
                padding-top: 64px;
            `;
        } else {
            return css``;
        }
    }}
`;
